export default {
    LOAD_USER_DATA: "LOAD_USER_DATA",
    HANDEL_INPUT_CHANGE: "HANDEL_INPUT_CHANGE",
    CLEAR_PHOTO: "CLEAR_PHOTO",
    UPLOAD_PHOTO: "UPLOAD_PHOTO",
    LOAD_USERS: "LOAD_USERS",
  };
  